import { gql } from '@apollo/client';

// ─── Mutations ───────────────────────────────────────────────────────────────

export const ADD_WAITLIST_ENTRY = gql`
  mutation AddWaitlistEntry(
    $name: String!
    $phone: String!
    $entryType: String!
    $email: String
    $location: String
    $message: String
    $isContact: Boolean
  ) {
    addWaitlistEntry(
      inputData: {
        name: $name
        phone: $phone
        entryType: $entryType
        email: $email
        location: $location
        message: $message
        isContact: $isContact
      }
    ) {
      success
      message
      errors
      data {
        id
        name
        phone
        email
        entryType
        location
        message
        isContact
        createdAt
        updatedAt
      }
    }
  }
`;

// ─── Queries ─────────────────────────────────────────────────────────────────

export const GET_WAITLIST_ENTRIES = gql`
  query GetWaitlistEntries($entryType: String!, $limit: Int, $skip: Int) {
    getWaitlistEntries(entryType: $entryType, limit: $limit, skip: $skip) {
      success
      message
      errors
      totalCount
      data {
        id
        name
        phone
        email
        entryType
        location
        message
        isContact
        createdAt
        updatedAt
      }
    }
  }
`;

// ─── Delete Account Operations ───────────────────────────────────────────────

export const SIMPLE_SIGNUP_SUBSCRIPTION = gql`
  subscription SimpleSignupSubscription($phone: String!) {
    simpleSignupSubscription(input: { phone: $phone }) {
      success
      status
      message
      phone
      otp
      requestId
      failureReason
      error {
        code
        field
        message
      }
    }
  }
`;

export const VERIFY_OTP_AND_LOGIN = gql`
  mutation VerifyOtpAndLogin($phone: String!, $otp: String!) {
    verifyOtpAndLogin(input: { phone: $phone, otp: $otp }) {
      success
      message
      otp
      requestId
      errors {
        code
        field
        message
      }
      token {
        authToken
        expiresIn
        refreshToken
        tokenType
      }
      user {
        id
        phone
        userType
      }
    }
  }
`;

export const ERASE_USER_PROFILE = gql`
  mutation EraseUserProfile($userId: String!) {
    eraseUserProfile(userId: $userId) {
      success
      message
      isUseOtp
      errors {
        code
        field
        message
      }
    }
  }
`;
